import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const ComplementItem = styled.div`
  padding: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-navy-blue);
  display: flex;
  justify-content: space-between;
  gap: 8px;

  .MuiRadio-colorSecondary.Mui-checked {
    color: var(--color-blue) !important;
  }

  .MuiIconButton-colorSecondary:hover {
    background-color: #329bfc1a;
  }

  .PrivateSwitchBase-root-39 {
    padding: 0;
  }

  .informations {
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    gap: 4px;

    p {
      font-size: 16px;
      line-height: 20px;
      user-select: none;
      color: var(--color-navy-blue);
    }

    .price {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: var(--color-alba-grandeza);
    }
  }
`;

export const Informations = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Quantidade = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const CustomIconButton = styled(IconButton)`
  :hover {
    background-color: #329bfc1a;
  }

  :disabled {
    svg {
      color: var(--color-gray-800);
    }
  }
  svg {
    color: var(--color-blue);
  }
`;
